export const systemEndpoints = {
  system: {},
};
